import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getColorForDownloadsCounter'
})
export class GetColorForDownloadsCounterPipe implements PipeTransform {

  transform(value:number, arg:Boolean) : string{

    let temp:number=22;
    if(arg)
        temp=62;

    if(value>=temp)
        return "red";
    else
        return "green";
    }
}
